import React from "react";
import createAbsolutePath from "createAbsolutePath";

import NavBarItemDropdownMenu from "Header/NavBarItemDropdownMenu";
import { ActiveProfileQuery } from "operations";

export const basePath = "/users/logIntoAccount";

const NavBarAccountDropdown = ({
  otherAccounts,
}: Pick<ActiveProfileQuery, "otherAccounts">) => (
  <>
    {otherAccounts?.length > 0 && (
      <NavBarItemDropdownMenu
        value="Switch To"
        options={otherAccounts.map(({ name, id }) => ({
          label: name,
          route: createAbsolutePath(`${basePath}/${id}`),
        }))}
      />
    )}
  </>
);

export default NavBarAccountDropdown;
